import { stateCodes, stateCodeToName } from '@newfront-insurance/core-address';
import { SelectInput } from '@newfront-insurance/core-ui';
import React from 'react';
export { A as AdminTRPCProvider } from './trpc-2b4d7b2f.esm.js';
export { f as formatFormikErrorToString } from './formik-daccc11e.esm.js';
import '@newfront-insurance/data-layer-client';
import '@newfront-insurance/react-provision';

const stateCodeOptions = stateCodes.map(stateCode => ({
  label: stateCodeToName.get(stateCode),
  value: stateCode
}));
function USStateSelector(props) {
  const {
    value,
    onChange,
    placeholder,
    excludedStates
  } = props;
  const options = excludedStates ? stateCodeOptions.filter(stateOption => !excludedStates.includes(stateOption.value)) : stateCodeOptions;
  return /*#__PURE__*/React.createElement(SelectInput, {
    value: value,
    onChange: state => {
      if (!state) {
        return onChange(undefined);
      }

      onChange(state);
    },
    placeholder: placeholder,
    options: options,
    showSelectAnOption: true,
    showSelectAnOptionDisabled: false
  });
}

export { USStateSelector };
